module.exports = __webpack_public_path__ + "img/no-data1.fd5f09b8.png";